"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../../providers/CetComponentsProvider");
var _hooks = require("../../../../hooks");
const useStyles = props => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    setStartDirection
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccSelectFilterStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      const marginInlineStart = isMobileView ? pxToRem(22) : 0;
      const marginInlineEnd = isMobileView ? pxToRem(22) : 0;
      const height = isMobileView ? pxToRem(48) : pxToRem(36);
      return {
        marginInlineStart,
        marginInlineEnd,
        height
      };
    };
    const contentDeviceProps = () => {
      const transform = isMobileView ? 'none' : `translateY(${pxToRem(-10)})`;
      const borderRadius = isMobileView ? pxToRem(5) : pxToRem(19);
      const top = isMobileView ? 0 : pxToRem(-2);
      return {
        transform,
        borderRadius,
        top
      };
    };
    const ccSelectFilter = (0, _css.css)({
      position: 'relative',
      ...deviceProps()
    });
    const ccSelectFilterContent = (0, _css.css)({
      boxSizing: 'border-box',
      width: `calc(100% + ${pxToRem(28)})`,
      height: pxToRem(36),
      padding: `${pxToRem(5)} ${pxToRem(12)}`,
      position: 'absolute',
      ...setStartDirection(-14),
      background: themeColors?.general.light,
      border: `1px solid ${themeColors?.general.border}`,
      display: 'flex',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
      overflow: 'hidden',
      ...contentDeviceProps(),
      input: {
        margin: 0,
        boxSizing: 'border-box',
        height: '100%',
        border: 'none',
        outline: 'none',
        flex: 'auto',
        fontSize: pxToRem(15),
        paddingInlineEnd: pxToRem(12),
        color: themeColors?.general.subText
      }
    });
    return {
      ccSelectFilter,
      ccSelectFilterContent
    };
  }, [isMobileView, pxToRem, setStartDirection, themeColors?.general.border, themeColors?.general.light, themeColors?.general.subText]);
  return {
    'cc-Select__filter': ccSelectFilterStyle.ccSelectFilter,
    'cc-Select__filter-content': ccSelectFilterStyle.ccSelectFilterContent
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;